module.exports = __webpack_public_path__ + "media/public/img/viator-review-icon-01-1d3954686f9b1e79ef588e0fe939bff1.svg";